<template>
  <div>
    <div class="site-mobile-menu site-navbar-target">
      <div class="site-mobile-menu-header">
        <div class="site-mobile-menu-close mt-3">
          <span class="icon-close2 js-menu-toggle"></span>
        </div>
      </div>
      <div class="site-mobile-menu-body"></div>
    </div>

    <div class="top-bar">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <a href="#" class=""
              ><span class="mr-2 icon-envelope-open-o"></span>
              <span class="d-none d-md-inline-block">qsahara@gmail.com</span></a
            >
            <span class="mx-md-2 d-inline-block"></span>
            <a href="#" class=""
              ><span class="mr-2 icon-phone"></span>
              <span class="d-none d-md-inline-block">(222) 11 22 33 44</span></a
            >

            <div class="float-right">
              <a href="#" class=""
                ><span class="mr-2 icon-twitter"></span>
                <span class="d-none d-md-inline-block">Twitter</span></a
              >
              <span class="mx-md-2 d-inline-block"></span>
              <a href="#" class=""
                ><span class="mr-2 icon-facebook"></span>
                <span class="d-none d-md-inline-block">Facebook</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <header
      class="site-navbar js-sticky-header site-navbar-target"
      role="banner"
    >
      <div class="container-fluid">
        <div class="row align-items-center position-relative">
          <div class="site-logo">
            <router-link to="/"
              ><img src="/images/menu/logo/1.png" alt=""
            /></router-link>
          </div>

          <div class="interaction-utils">
            <ul class="site-menu">
              <li class="has-children">
                <a
                  v-if="locale === 'en'"
                  class="nav-link"
                  href="javascript:void(0);"
                >
                  <img
                    src="/images/flags/us.jpg"
                    alt="lang-image"
                    height="12"
                  />
                </a>
                <a
                  v-if="locale === 'fr'"
                  class="nav-link"
                  href="javascript:void(0);"
                >
                  <img
                    src="/images/flags/french.jpg"
                    alt="lang-image"
                    height="12"
                  />
                </a>
                <ul class="dropdown arrow-top">
                  <li>
                    <a
                      v-if="locale === 'en'"
                      href="javascript:void(0);"
                      class="dropdown-item notify-item"
                      @click.prevent="changeLocale('fr')"
                    >
                      <img
                        src="/images/flags/french.jpg"
                        alt="lang-image"
                        class="mr-1"
                        height="12"
                      />
                      <span class="align-middle">Français</span>
                    </a>
                  </li>

                  <li>
                    <a
                      v-if="locale === 'fr'"
                      href="javascript:void(0);"
                      class="dropdown-item notify-item"
                      @click.prevent="changeLocale('en')"
                    >
                      <img
                        src="/images/flags/us.jpg"
                        alt="lang-image"
                        class="mr-1"
                        height="12"
                      />
                      <span class="align-middle">Anglais</span>
                    </a>
                  </li>
                </ul>
              </li>
              <li class="has-children">
                <a class="nav-link">
                  <i class="fa fa-shopping-cart"></i>
                  <span
                    class="badge badge-danger badge-pill float-right ml-1"
                    >{{ items.length }}</span
                  >
                </a>
                <ul class="dropdown arrow-top cart-items-list">
                  <li class="cart-header my-2">
                    <span> Panier ({{ items.length }}) </span>
                    <button @click.prevent="clearPanier">
                      Vider le panier
                    </button>
                  </li>
                  <li
                    v-for="article in items"
                    :key="article.id"
                    class="cart-item mt-2"
                  >
                    <img
                      v-if="article.image === null"
                      :src="URL + '/files/no_image_article.png'"
                      alt="Image"
                    />
                    <img
                      v-if="article.image"
                      :src="URL + '/files/' + article.image"
                      alt="Image"
                    />
                    <p class="cart-item-info pt-2">
                      <strong :class="Number(user.prix) === 0 ? 'mt-1' : ''">{{
                        JSON.parse(article.article_libelle)[locale]
                          ? JSON.parse(article.article_libelle)[locale]
                          : "###"
                      }}</strong>
                      <small v-if="Number(user.prix) === 1">{{
                        article.prix | currency
                      }}</small>
                    </p>
                  </li>

                  <li class="cart-footer">
                    <router-link
                      :to="{ name: 'mini-cart' }"
                      class="link text-center"
                    >
                      Voir mon panier
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div class="col-12">
            <nav class="site-navigation text-right ml-auto" role="navigation">
              <ul
                class="site-menu main-menu js-clone-nav ml-auto d-none d-lg-block"
              >
                <li class="has-children ml-3">
                  <a href="#about-section" class="nav-link user">
                    <span v-if="isLoggedIn">
                      <img
                        v-if="user.image === null"
                        :src="URL + '/avatars/no_avatar/no_avatar.png'"
                        alt="Avatar"
                        class="rounded-circle user-avatar"
                      />
                      <img
                        v-else
                        :src="URL + '/avatars/' + user.image"
                        alt="Avatar"
                        class="rounded-circle user-avatar"
                      />
                    </span>
                    {{ user.nom }}
                  </a>
                  <ul class="dropdown arrow-top">
                    <li>
                      <router-link to="/profil" class="nav-link"
                        >Profil</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/cotations" class="nav-link"
                        >Mes demandes de cotations</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/my-devis" class="nav-link"
                        >Mes devis reçus</router-link
                      >
                    </li>
                    <li>
                      <a @click.prevent="logout" class="nav-link"
                        >Deconnexion</a
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>

          <div class="toggle-button d-inline-block d-lg-none">
            <a href="#" class="site-menu-toggle py-5 js-menu-toggle text-black"
              ><span class="icon-menu h3"></span
            ></a>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
// import ShoppingCart from './ShoppingCart.vue';
import headerMixin from "@/mixins/headerMixin";
import constant from "@/constant";
export default {
  name: "Header",
  data() {
    return {
      URL: constant.URL_FILE,
    };
  },
  methods: {
    logout: function () {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push({ name: "login" });
      });
    },
    changeLocale: function (locale) {
      this.$store.dispatch("configapp/setLocale", {
        locale: locale,
      });
    },
    clearPanier() {
      this.$store.dispatch("cotation/reinitCotation");
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    user() {
      return this.$store.getters["auth/userp"];
    },
    locale() {
      return this.$store.getters["configapp/locale"];
    },
    items() {
      return this.$store.getters["cotation/currentCotation"].items;
    },
  },
  mixins: [headerMixin],
};
</script>

<style lang="scss">
@import "@/assets/scss/style";
</style>
